var map = {
	"./build/coming-soon.md": [
		199,
		4
	],
	"./configuration/basics.md": [
		200,
		5
	],
	"./configuration/imports.md": [
		201,
		6
	],
	"./configuration/other.md": [
		202,
		7
	],
	"./configuration/pages.md": [
		203,
		8
	],
	"./configuration/responsive-specimens.md": [
		204,
		9
	],
	"./configuration/theming.md": [
		205,
		10
	],
	"./guides/frameworks.md": [
		206,
		11
	],
	"./guides/markdown.md": [
		207,
		12
	],
	"./guides/react.md": [
		208,
		13
	],
	"./guides/webpack-babel.md": [
		209,
		14
	],
	"./installation/create-catalog.md": [
		210,
		15
	],
	"./intro.md": [
		211,
		16
	],
	"./react-integration.md": [
		212,
		17
	],
	"./specimens/audio.md": [
		213,
		18
	],
	"./specimens/code.md": [
		214,
		19
	],
	"./specimens/color-palette.md": [
		215,
		20
	],
	"./specimens/color.md": [
		216,
		21
	],
	"./specimens/download.md": [
		217,
		22
	],
	"./specimens/hint.md": [
		218,
		23
	],
	"./specimens/html.md": [
		219,
		24
	],
	"./specimens/image.md": [
		220,
		25
	],
	"./specimens/overview.md": [
		221,
		26
	],
	"./specimens/react.md": [
		222,
		27
	],
	"./specimens/table.md": [
		223,
		28
	],
	"./specimens/type.md": [
		224,
		29
	],
	"./specimens/video.md": [
		225,
		30
	],
	"./static/coming-soon.md": [
		226,
		31
	],
	"./test/test.md": [
		227,
		32
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 196;
module.exports = webpackAsyncContext;